module.exports = __webpack_public_path__ + "static/media/Banos_V2.1df8a1fd.png";